import React from 'react';
import { Outlet } from 'react-router-dom';
import CallToAction from '../components/CallToAction';
import DefaultFooter from '../shared/DefaultFooter';
import DefaultHeader from '../shared/DefaultHeader';

const DefaultLayout = () => {
  return (
    <>
      <DefaultHeader />
      <Outlet />
      <CallToAction />
      <DefaultFooter />
    </>
  );
};

export default DefaultLayout;